import React, {lazy} from 'react';
import {useParams} from "react-router-dom";
import AdminSystemLayout from "@containers/adminSystem/layout/AdminSystemLayout";

const AdminUsersTable = lazy(() => import('@containers/adminSystem/users/AdminUsersTable'))
const AdminDevicesTable = lazy(() => import('@containers/adminSystem/devices/AdminDevicesTable'))
const AdminEmployeesTable = lazy(() => import('@containers/adminSystem/employees/AdminEmployeesTable'))
const AdminUnregisteredTable = lazy(() => import('@containers/adminSystem/unregistered/AdminUnregisteredTable'))
const AdminEmployeeEdit = lazy(() => import('@containers/adminSystem/employees/edit/AdminEmployeeEdit'))
const AdminUserEdit = lazy(() => import('@containers/adminSystem/users/edit/AdminUserEdit'))
const AdminUserCreate = lazy(() => import('@containers/adminSystem/users/edit/AdminUserCreate'))
const AdminDeviceEdit = lazy(() => import('@containers/adminSystem/devices/edit/AdminDeviceEdit'))
const AdminDeviceCreate = lazy(() => import('@containers/adminSystem/devices/edit/AdminDeviceCreate'))

export const AdminUsersPage = () => <AdminSystemLayout><AdminUsersTable/></AdminSystemLayout>

export const AdminUserNewPage = () => <AdminSystemLayout><AdminUserCreate/></AdminSystemLayout>

export const AdminUserEditPage = () => {
	const {userId} = useParams()
	return <AdminSystemLayout><AdminUserEdit key={userId} userId={Number(userId)}/></AdminSystemLayout>
}

export const AdminDevicesPage = () => <AdminSystemLayout><AdminDevicesTable/></AdminSystemLayout>

export const AdminDeviceNewPage = () => <AdminSystemLayout><AdminDeviceCreate/></AdminSystemLayout>

export const AdminDeviceEditPage = () => {
	const {deviceId} = useParams()
	return <AdminSystemLayout><AdminDeviceEdit key={deviceId} deviceId={Number(deviceId)}/></AdminSystemLayout>
}

export const AdminEmployeesPage = () => <AdminSystemLayout><AdminEmployeesTable/></AdminSystemLayout>

export const AdminEmployeeNewPage = () => <AdminSystemLayout><AdminEmployeeEdit/></AdminSystemLayout>

export const AdminEmployeeEditPage = () => {
	const {accountId, employeeId} = useParams()
	return (
		<AdminSystemLayout>
			<AdminEmployeeEdit key={employeeId} accountId={Number(accountId)} employeeId={Number(employeeId)}/>
		</AdminSystemLayout>
	)
}

export const AdminUnregisteredPage = () => <AdminSystemLayout><AdminUnregisteredTable/></AdminSystemLayout>
